import CopyCdk from './CopyCdk'
import ChooseRole from './ChooseRole'
import ApplyDiscuss from './ApplyDiscuss'
import Topic from './Topic'
import PublishComment from './PublishComment'
import Report from './Report'
import Shield from './Shield'
export default {
    copyCdk: {
        name: 'copycdk_modal',
        FormTemplate: CopyCdk,
    },
    chooseRole: {
        title: '选择角色',
        name: 'chooserole_modal',
        FormTemplate: ChooseRole,
    },
    applyDiscuss: {
        title: '话题申请',
        fullscreen: true,
        FormTemplate: ApplyDiscuss,
        okText: '提交'
    },
    topic: {
        name: 'topic_modal',
        fullscreen: true,
        FormTemplate: Topic
    },
    publishComment: {
        title: '发表评论',
        name: 'publish_comment',
        fullscreen: true,
        FormTemplate: PublishComment,
        okText: '发表'
    },
    report: {
        title: '举报',
        FormTemplate: Report
    },
    shield: {
        title: '屏蔽',
        FormTemplate: Shield
    }
}